export default __webpack_public_path__ + "static/media/hyper-custom-mobile.a658ecb5.png";